<template>
  <div id="app">
    <a-config-provider :locale="locale">
      <router-view/>
    </a-config-provider>
  </div>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';

export default {
  name: 'App',
  data() {
    return {
      locale: zhCN,
    };
  },
}
</script>

<style lang="less">
@import url('./global.less');
@import url('./styles/reset.less');
@import url('./styles/variables.less');
</style>
